<template>
  <div class="relative-container">
    <v-menu
      attach
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :z-index="9999"
      :disabled="disbaled"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined dense
          v-model="dateFormatted"
          :label="label"
          :disabled="disbaled"
          hide-details="auto"
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          @blur="onBlur"
          v-on="on"
          class="date-picker-field"
        ></v-text-field>
      </template>
      <v-date-picker locale="es-SV" v-model="date" no-title scrollable @input="menu = false"  :disabled="disbaled">

      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: ["label", "value", "reset", "disbaled"],
  data() {
    return {
      menu: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateFormatted: this.value
        ? this.value
        : this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
          ),
      isdisbaled: false,
    };
  },
  mounted() {
    this.dateFormatted = this.value ? this.value : this.formatDate(this.date);
    this.$emit("dateSelected", this.dateFormatted);
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.$emit("dateSelected", this.dateFormatted);
    },
    value() {
      this.dateFormatted = this.value;
    },
    reset() {
      this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.dateFormatted = this.value
        ? this.value
        : this.formatDate(
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
          );
    },
    disbaled() {
      this.isdisbaled = this.disbaled
    },
  },
  methods: {
    onBlur() {
      if (this.isValidDate(this.dateFormatted)) {
        this.date = this.parseDate(this.dateFormatted);
      } else {
        // Reset to current date if invalid
        this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.dateFormatted = this.formatDate(this.date);
      }
    },
    isValidDate(dateString) {
      if (!dateString) return false;
      const [day, month, year] = dateString.split("/");
      if (!day || !month || !year) return false;
      const dayNum = parseInt(day, 10);
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);
      if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) return false;
      if (monthNum < 1 || monthNum > 12) return false;
      if (dayNum < 1 || dayNum > 31) return false;
      const date = new Date(yearNum, monthNum - 1, dayNum);
      return date.getFullYear() === yearNum && date.getMonth() === monthNum - 1 && date.getDate() === dayNum;
    },
    formatDate(date) {
      if (!date) return null;
      
      const [year, month, day] = date.split("-");
      return this.moment(`${month}/${day}/${year}`, 'MM/DD/YYYY').format('DD/MM/YYYY');
    },
    parseDate(date) {
      if (!date) return null;
      if (!this.isValidDate(date)) return null; // No parsear fechas inválidas
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>

/* Responsividad para móviles */
@media (max-width: 600px) {
  .relative-container {
    margin-bottom: 8px;
  }
  
  .date-picker-field {
    font-size: 0.875rem;
  }
  
  .date-picker-field >>> .v-input__prepend-outer {
    margin-right: 8px;
  }
  
  .date-picker-field >>> .v-text-field__details {
    padding-top: 4px;
  }
}

@media (max-width: 960px) and (min-width: 601px) {
  .relative-container {
    margin-bottom: 6px;
  }
}
</style>